import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.css'],
})
export class DeclarationComponent implements OnInit {
  declaration: FormGroup;
  private saveApi = environment.url + 'coe/annexure/save';
  private getApi = environment.url + 'coe/annexure/get?id=';
  private declarationGet = environment.url + 'coe/declaration/get?id=';
  private declarationSave = environment.url + 'coe/declaration/save';
  constructor(
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    this.declaration = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      terms1: ['', [Validators.required]],
      terms2: ['', [Validators.required]],
    });
  }
  coeStatus;
  applicationNo;
  // This is the declaration component for CoE applications
  // It handles the declaration form, file uploads, and submission of the CoE application
  ngOnInit(): void {
    this.getDataApi();
    this.declarationGetApi();
    this.checkRegistrationStatus();
    this.coeStatus = sessionStorage.getItem('CoeStatus');
  }

  showForm: boolean = false;
  showForm2: boolean = false;
  get setting() {
    return this.declaration.controls;
  }

  getValue: any = {};
  disableBtn: boolean;
  show;
  // This function fetches the data for the declaration form
  // It checks if the form is editable and sets the form values accordingly
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.getValue = data;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (data.responseStatus != 'Failed') {
          this.declaration.patchValue(data);
          if (this.getValue.annexureDocName) {
            this.FileValue = this.getValue.annexureDoc;
            this.FileName = this.getValue.annexureDocName;
            this.disNames = '✔ Uploaded';
            this.disName = '✔ Uploaded';
          }
        }
      });
  }
  getValues;
  showDeclaration;
  showDeclarations;
  // This function fetches the declaration data for the application
  // It checks if the form is editable and sets the form values accordingly
  declarationGetApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(
        this.declarationGet + sessionStorage.getItem('applicationId'),
        '',
        'get'
      )
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');

        this.getValues = data;
        this.applicationNo = data.applicationNo;
        if (data.edit === false) {
          this.showForm2 = true;
        } else {
          this.showForm2 = false;
        }
        if (data.submitButton == false) {
          this.showDeclaration = true;
          this.showDeclarations = false;
        } else {
          this.showDeclaration = false;
          this.showDeclarations = true;
        }
        if (data.responseStatus != 'Failed') {
          this.declaration.patchValue(data);
        }
      });
  }
  // Variables for file upload
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 5;
  logoCheck = false;
  fileErrorShow = false;
  fileError = false;
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = '✔ Uploaded';
          this.fileError = false;
          this.fileErrorShow = false;
          this.notify.notifysuccess('File Upload Success !');
          let req = {
            annexureDoc: this.FileValue,
            annexureDocName: this.FileName,
            id: this.getValue.id,
            applicationId: sessionStorage.getItem('applicationId'),
          };

          this.saveBtn(req);
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // This function handles the file upload and saves the file data
  // It checks if the file is selected and uploads it to the server
  saveBtn(req) {
    if (req) {
      if (this.FileValue == '') {
        this.fileError = true;
      } else {
        this.fileError = false;
      }
    }
    if (this.FileValue != '') {
      this.fileError = false;
      req.annexureDoc = this.FileValue;
      req.annexureDocName = this.FileName;
    } else {
      this.fileError = true;
    }
    if (this.fileError == false) {
      this.getdata.amizhthLoader('show');
      this.makeapi.method(this.saveApi, req, 'post').subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.fileErrorShow = false;
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          this.declarationGetApi();
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
    } else {
      this.fileError = true;
    }
  }
  // This function handles the final save of the declaration form
  // It checks if the terms are accepted and displays a modal for confirmation
  declarationValue;
  finalSave() {
    this.declarationValue = this.declaration.value;
    this.declaration.value.applicationId =
      sessionStorage.getItem('applicationId');
    if (
      this.declarationValue.terms1 == false ||
      this.declarationValue.terms2 == false
    ) {
      if (this.declarationValue.terms1 == false) {
        this.declaration.get('terms1')?.setValue('');
      }
      if (this.declarationValue.terms2 == false) {
        this.declaration.get('terms2')?.setValue('');
      }
      this.declaration.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      document.getElementById('editModal').style.display = 'block';
    }
  }
  // This function downloads the CoE declaration file
  // It opens the file in a new tab
  downloadFile() {
    const url =
      'https://startuptn-public-files.s3.ap-south-1.amazonaws.com/Annexure_II_CoE.pdf';
    window.open(url, '_blank');
  }
  declaration1(event) {
    if (event == true) {
      this.declaration.get('terms1')?.setValue(event);
    } else {
      this.declaration.get('terms1')?.setValue('');
    }
  }
  // This function handles the acceptance of the second declaration term
  // It sets the value of the terms2 field in the form
  declaration2(event) {
    if (event == true) {
      this.declaration.get('terms2')?.setValue(event);
    } else {
      this.declaration.get('terms2')?.setValue('');
    }
  }
  // This function saves the declaration form data
  // It sends the form data to the server and updates the UI based on the response
  saveModal() {
    let data = {
      id: this.declarationValue.id,
      terms1: this.declarationValue.terms1,
      terms2: this.declarationValue.terms2,
      applicationId: sessionStorage.getItem('applicationId'),
      status: 1,
    };
    this.makeapi
      .method(this.declarationSave, data, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.fileErrorShow = false;
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          this.declarationGetApi();
          document.getElementById('editModal').style.display = 'none';
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
  }
  // This function closes the modal dialogs
  // It hides the edit and re-submit modals
  closeModal(): void {
    document.getElementById('editModal').style.display = 'none';
    document.getElementById('reSubmitModal').style.display = 'none';
  }
  // This function handles the re-submission of the declaration form
  // It checks if the terms are accepted and displays a modal for confirmation
  reSubmit() {
    this.declarationValue = this.declaration.value;
    this.declaration.value.applicationId =
      sessionStorage.getItem('applicationId');
    if (
      this.declarationValue.terms1 == false ||
      this.declarationValue.terms2 == false
    ) {
      if (this.declarationValue.terms1 == false) {
        this.declaration.get('terms1')?.setValue('');
      }
      if (this.declarationValue.terms2 == false) {
        this.declaration.get('terms2')?.setValue('');
      }
      this.declaration.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      document.getElementById('reSubmitModal').style.display = 'block';
    }
  }
  // This function handles the re-submission of the declaration form
  // It sends the form data to the server and updates the UI based on the response
  reSubmitModal() {
    let data = {
      id: this.declarationValue.id,
      terms1: this.declarationValue.terms1,
      terms2: this.declarationValue.terms2,
      applicationId: sessionStorage.getItem('applicationId'),
      status: 6,
    };
    this.makeapi
      .method(this.declarationSave, data, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.fileErrorShow = false;
        if (data.responseStatus == 'Success') {
          this.notify.notifysuccess(data.responseStatus);
          this.getDataApi();
          this.declarationGetApi();
          document.getElementById('reSubmitModal').style.display = 'none';
        } else {
          this.notify.notifyError(data.responseStatus);
        }
      });
  }
  // This function checks if the registration is closed based on a deadline
  // It sets a boolean flag to indicate the registration status
  isRegistrationClosedCOE: boolean = false;
  checkRegistrationStatus() {
    const deadline = new Date(2026, 2, 4, 11, 30, 0); // March 2, 2026
    const now = new Date();
    this.isRegistrationClosedCOE = now >= deadline;
  }
}
